/* tslint:disable */
/* eslint-disable */
/**
 * Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigninRequestWithAuthenticationToken
 */
export interface SigninRequestWithAuthenticationToken {
    /**
     * 
     * @type {string}
     * @memberof SigninRequestWithAuthenticationToken
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SigninRequestWithAuthenticationToken
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof SigninRequestWithAuthenticationToken
     */
    authenticationToken: string;
}

/**
 * Check if a given object implements the SigninRequestWithAuthenticationToken interface.
 */
export function instanceOfSigninRequestWithAuthenticationToken(value: object): value is SigninRequestWithAuthenticationToken {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('authenticationToken' in value) || value['authenticationToken'] === undefined) return false;
    return true;
}

export function SigninRequestWithAuthenticationTokenFromJSON(json: any): SigninRequestWithAuthenticationToken {
    return SigninRequestWithAuthenticationTokenFromJSONTyped(json, false);
}

export function SigninRequestWithAuthenticationTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigninRequestWithAuthenticationToken {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
        'authenticationToken': json['authentication-token'],
    };
}

export function SigninRequestWithAuthenticationTokenToJSON(value?: SigninRequestWithAuthenticationToken | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'password': value['password'],
        'authentication-token': value['authenticationToken'],
    };
}

